import React from 'react';
import { SVGProps } from './type';

export const IconBankAccount = ({ fill }: SVGProps) => {
  return (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.107 1.571a1.11 1.11 0 0 1 0.78 0L20.775 4.905a1.11 1.11 0 0 1 0.72 1.039v3.333a1.11 1.11 0 0 1 -1.11 1.11h-1.111v8.887h1.11a1.11 1.11 0 1 1 0 2.222H2.612a1.11 1.11 0 0 1 0 -2.222h1.11V10.386h-1.11A1.11 1.11 0 0 1 1.5 9.276V5.943a1.11 1.11 0 0 1 0.72 -1.039zM5.943 10.386v8.887h2.222V10.386zm4.443 0v8.887h2.223V10.386zm4.444 0v8.887h2.22V10.386zm3.332 -2.22H3.721v-1.454l7.776 -2.916 7.776 2.916v1.452z"
        fill={fill}
      />
    </g>
  );
};
